import { Link } from 'react-router-dom';
import SearchBox from '@/components/feature/SearchBox';
import { categories } from '@/mocks/categories';
import { getGenreCount, getHotMovies, formatPopularity } from '@/utils/movies';

const hotMovies = getHotMovies(8);

export default function HomeSidebar() {
  return (
    <aside className="space-y-5">
      <div className="rounded-lg border border-background-200 bg-background-100 p-5">
        <h3 className="mb-3 flex items-center gap-2 text-sm font-bold text-foreground-950">
          <i className="ri-search-2-line text-accent-500"></i>
          搜索入口
        </h3>
        <SearchBox size="md" />
        <div className="mt-3 flex flex-wrap gap-2">
          {['科幻', '悬疑', '爱情', '动作'].map((tag) => (
            <Link
              key={tag}
              to={`/search?q=${encodeURIComponent(tag)}`}
              className="rounded-full border border-background-200 px-3 py-1 text-xs text-foreground-600 transition hover:border-accent-400 hover:text-accent-700"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-100 p-5">
        <h3 className="mb-3 flex items-center gap-2 text-sm font-bold text-foreground-950">
          <i className="ri-apps-2-line text-accent-500"></i>
          分类导航
        </h3>
        <div className="grid grid-cols-2 gap-2">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category?genre=${encodeURIComponent(category.slug)}`}
              className="flex items-center justify-between rounded-md border border-background-200 bg-background-50 px-3 py-2 text-sm text-foreground-800 transition hover:border-accent-400 hover:text-accent-700"
            >
              <span className="flex items-center gap-1.5">
                <i className={`${category.icon} text-foreground-500`}></i>
                {category.name}
              </span>
              <span className="text-xs text-foreground-500">{getGenreCount(category.slug)}</span>
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-100 p-5">
        <h3 className="mb-4 flex items-center gap-2 text-sm font-bold text-foreground-950">
          <i className="ri-fire-line text-accent-500"></i>
          热门推荐榜
        </h3>
        <ol className="space-y-3">
          {hotMovies.map((movie, i) => (
            <li key={movie.id}>
              <Link to={`/detail/${movie.id}`} className="group flex items-center gap-3">
                <span className="flex w-5 shrink-0 items-center justify-center">
                  <span
                    className={`text-sm font-extrabold ${i < 3 ? 'text-accent-500' : 'text-foreground-500'}`}
                  >
                    {i + 1}
                  </span>
                </span>
                <div className="h-14 w-10 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={movie.poster}
                    alt={`${movie.title} 电影海报`}
                    title={`${movie.title} - 电影在线观看与剧情介绍`}
                    className="h-full w-full object-top transition duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-foreground-900 transition group-hover:text-accent-700">
                    {movie.title}
                  </p>
                  <p className="mt-1 flex items-center gap-2 text-[11px] text-foreground-500">
                    <span className="flex items-center gap-0.5 text-secondary-900">
                      <i className="ri-star-fill text-secondary-600"></i>
                      {movie.rating.toFixed(1)}
                    </span>
                    <span>{formatPopularity(movie.popularity)} 观看</span>
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </aside>
  );
}